import { render, staticRenderFns } from "./service-weather.vue?vue&type=template&id=b2f37f52&"
import script from "./service-weather.vue?vue&type=script&lang=js&"
export * from "./service-weather.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports